module.exports = __webpack_public_path__ + "media/images/ruby-64d695efab06c7e7928d5c24c40375f0.png";